module.exports = __webpack_public_path__ + "img/2-5.1a735911.png";